import { Box, Button, Divider } from '@mui/material';
import RetrosToolbar from './RetrosToolbar';
import { useProjectRetroContext } from '../../context';
import { ArticleFieldsType, ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import SummarizeLearnings from './SummarizeLearnings';
import LessonTypeSummaryBar from './LessonTypeSummaryBar';
import { getArticleFormDefaultValues, useArticleInputFields } from '@buildwise/libs/posts';
import { Dictionary, keyBy } from 'lodash';
import { useMemo } from 'react';
import { ConfigEntryType } from 'config/config';
import AddLineIcon from 'remixicon-react/AddLineIcon';
import { useFormContext } from 'react-hook-form';
import { PostFormData } from '@buildwise/pages/addPost/hooks/useAddPostForm';
import { useParams } from 'react-router-dom';
import { useBuildWiseModules } from '@buildwise/libs/helpers';

function RetrosHeader({
  filteredLessons,
  phasesWithCount,
}: {
  filteredLessons: ArticleType[];
  phasesWithCount: Record<string, number>;
}) {
  const {
    state: { isFullScreen, articleFields },
    dispatch,
  } = useProjectRetroContext();
  const { articleFieldsToRender } = useArticleInputFields({
    articleFieldsType: ArticleFieldsType.LESSON,
    isEditing: false,
  });
  const enabledArticleFieldsToRender: Dictionary<ConfigEntryType | undefined> = useMemo(
    () => keyBy(articleFieldsToRender, 'entryCode'),
    [articleFieldsToRender],
  );
  const { reset } = useFormContext<PostFormData>();
  const { projectId = '' } = useParams();
  const { singularRetrospectivesModuleName } = useBuildWiseModules();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={isFullScreen ? 'flex-start' : 'space-between'}
      gap={1}
    >
      {!isFullScreen && (
        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            startIcon={<AddLineIcon />}
            onClick={() => {
              reset({
                ...getArticleFormDefaultValues({
                  defaultProjectId: projectId,
                  articleFields,
                }),
                projectPhases: '',
                projectSpecific: true,
              });
              dispatch(({ state }) => ({
                payload: {
                  ...state,
                  isOpenedLessonForm: true,
                  selectedArticle: undefined,
                  articleIds: [],
                  showSelectMilestone: false,
                },
              }));
            }}
            sx={(theme) => ({
              backgroundColor: theme.palette.custom.white,
            })}
          >
            Add {singularRetrospectivesModuleName}
          </Button>
        </Box>
      )}
      <Box display="flex" alignItems="center" gap={1}>
        {filteredLessons?.length > 0 && (
          <SummarizeLearnings lessons={filteredLessons} phasesWithCount={phasesWithCount} />
        )}
        <RetrosToolbar lessons={filteredLessons} />
      </Box>
    </Box>
  );
}

export default RetrosHeader;
